import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      'ol,ul': {
        marginLeft: 30,
      },
      ol: {
        listStyleType: 'decimal',
      },
      ul: {
        listStyleType: 'disc',
      },
      li: {
        margin: '10px 0',
      },
      a: {
        color: theme.fn.primaryColor(),
      },
    },
  }
})
